import api, { prettify } from 'service/api-service';
import { distributor, isMochipay } from 'config';
import localDataService from 'service/local-data-service';
import { fromApi } from 'utils/api-helper';
import { concat, uniq } from 'lodash';
import { compareOriginal } from 'utils/city-helper';

class Repository {
  fetchBootStraps = async () => {
    const [err, value] = await fromApi(api.fetchBootstraps());
    if (err) return [err];
    return [null, value.data.data];
  };

  // poi

  fetchGasStations = async () => {
    const memoryCache = localDataService.getGasStations();
    if (memoryCache) return [null, memoryCache];
    let [err, value] = await fromApi(api.fetchGasStations());
    if (err) return [err];
    localDataService.saveGasStations(value.data.data.gasStations);
    return [null, value.data.data.gasStations];
  };

  fetchParkinglots = async () => {
    const memoryCache = localDataService.getParkinglots();
    if (memoryCache) return [null, memoryCache];
    let [err, value] = await fromApi(api.fetchParkinglots());
    if (err) return [err];
    localDataService.saveParkinglots(value.data.data.parkinglots);
    console.log(value.data.data.parkinglots.length);
    return [null, value.data.data.parkinglots];
  };

  fetchChainStores = async () => {
    const memoryCache = localDataService.getChainStores();
    if (memoryCache) return [null, memoryCache];

    let [err, value] = await fromApi(api.fetchChainStores());
    if (err) return [err];

    let currentPage = 1;
    let chainStoresTotalData = value.data.data;
    const chainStoresTotalPage = value.data.paging.totalPage;
    if (chainStoresTotalPage > 1) {
      while (currentPage !== chainStoresTotalPage) {
        currentPage++;
        let [err, value] = await fromApi(api.fetchChainStores(currentPage));
        if (err) return [err];
        chainStoresTotalData = chainStoresTotalData.concat(value.data.data);
      }
    }

    localDataService.saveChainStores(chainStoresTotalData);
    return [null, chainStoresTotalData];
  };

  fetchCarBeauty = async () => {
    const memoryCache = localDataService.getVehicleMaintenance();
    if (memoryCache) return [null, memoryCache];
    let [err, data] = await this.fetchChainStores();
    if (err) return [err];
    const result = data.filter(data => data.transactionTypes.includes('vehicle_maintenance'));
    localDataService.saveVehicleMaintenance(result);
    return [null, result];
  };

  fetchAutoRepair = async () => {
    const memoryCache = localDataService.getVehicleRepair();
    if (memoryCache) return [null, memoryCache];
    let [err, data] = await this.fetchChainStores();
    if (err) return [err];
    const result = data.filter(data => data.transactionTypes.includes('vehicle_repair'));
    localDataService.saveVehicleRepair(result);
    return [null, result];
  };

  fetchCarWash = async () => {
    const memoryCache = localDataService.getWashCar();
    if (memoryCache) return [null, memoryCache];
    let [err, data] = await this.fetchChainStores();
    if (err) return [err];
    const result = data.filter(data => data.transactionTypes.includes('wash_car'));
    localDataService.saveWashCar(result);
    return [null, result];
  };

  fetchCharging = async () => {
    const memoryCache = localDataService.getCharging();
    if (memoryCache) return [null, memoryCache];
    let [err, data] = await this.fetchChainStores();
    if (err) return [err];
    const result = data.filter(data => data.transactionTypes.includes('charging'));
    localDataService.saveCharging(result);
    return [null, result];
  };

  fetchPoiCardTagBoards = async () => {
    let [err, value] = await fromApi(api.fetchBoards('poi_card_tag'));
    if (err) return [err];
    return [null, value.data.data.poiCardTag];
  };

  fetchPoiBannerBoards = async code => {
    let [err, value] = await fromApi(api.fetchBoards(code));
    if (err) return [err];
    return [null, value.data.data];
  };

  fetchPoiCollections = async () => {
    let [err, value] = await fromApi(api.fetchPoiCollections());
    if (err) return [err];
    return [null, value.data.data];
  };

  // promotion

  fetchPromotions = async () => {
    const memoryCache = localDataService.getPromotions();
    if (memoryCache) return [null, memoryCache];
    const dist = isMochipay ? undefined : distributor();
    const [err, value] = await fromApi(api.fetchPromotions(undefined, 'not_end', dist));
    if (err) return [err];
    const result = value.data.data.map(p => {
      p.badageLabel = p.badageLabel || '麻吉專屬';
      p.distributor = undefined ? 'AUTOPASS' : p.distributor.uid;
      p.displayPromotionTypes = p.displayPromotionTypes.map(t => (!t ? 'OnStreetParkingPromotion' : t));
      return p;
    });
    localDataService.savePromotions(result);
    return [null, result];
  };

  fetchPromotionsService = async () => {
    const [err, value] = await fromApi(api.fetchPromotions(undefined, 'not_end', undefined, true));
    if (err) return [err];
    const result = value.data.data.map(p => {
      p.badageLabel = p.badageLabel || '麻吉專屬';
      p.distributor = undefined ? 'AUTOPASS' : p.distributor.uid;
      p.displayPromotionTypes = p.displayPromotionTypes.map(t => (!t ? 'OnStreetParkingPromotion' : t));
      return p;
    });
    return [null, result];
  };

  fetchPromotionBoards = async () => {
    const memoryCache = localDataService.getPromotionBoards();
    if (memoryCache) return [null, memoryCache];
    const [err, value] = await fromApi(api.fetchBoards('promotions_content_ad'));
    if (err) return [err];
    localDataService.savePromotionBoards(value.data.data);
    return [null, value.data.data];
  };

  fetchPromotionCollections = async () => {
    const memoryCache = localDataService.getPromotionCollections();
    if (memoryCache) return [null, memoryCache];
    const dist = isMochipay ? undefined : distributor();
    const [err, value] = await fromApi(api.fetchPromotionCollections(dist));
    if (err) return [err];
    localDataService.savePromotionCollections(value.data.data);
    return [null, value.data.data];
  };

  fetchPromotionCollectionBoards = async () => {
    const memoryCache = localDataService.getPromotionCollectionBoards();
    if (memoryCache) return [null, memoryCache];
    const [err, value] = await fromApi(api.fetchBoards('intro_promotion_collection'));
    if (err) return [err];
    const data = value.data.data.introPromotionCollection;
    localDataService.savePromotionCollectionBoards(data);
    return [null, data];
  };

  fetchPromotionUserUsageStatus = async id => {
    const [err, value] = await fromApi(api.fetchPromotionUserUsageStatus(id));
    if (err) return [err];
    return [null, value.data.data];
  };

  fetchStreetParkingBillCities = async () => {
    let [err, value] = await this.fetchBootStraps();
    if (err) return [err];
    let autoPay = value.autoPayStreetParkingBillsCities.map(x => x.id);
    let scan = value.scanStreetParkingBillsCities.map(x => x.id);
    let search = value.searchStreetParkingBillsCities.map(x => x.id);
    let citySupport = uniq(concat(autoPay, scan, search)).sort((a, b) => compareOriginal(a, b));
    return [null, citySupport];
  };

  // 登入

  fetchOtp = async (distributor, mobile) => {
    const [err, value] = await fromApi(api.fetchOtp(distributor, mobile));
    if (err) return [err];
    return [null, value];
  };

  fetchAuth = async (distributor, mobile, code) => {
    const [err, value] = await fromApi(api.fetchAuth(distributor, mobile, code));
    if (err) return [err];
    return [null, value.data.data];
  };

  logout = async () => {
    const [err, value] = await fromApi(api.logout());
    if (err) return [err];
    return [null, value];
  };

  // 會員

  fetchMe = async () => {
    const [err, value] = await fromApi(api.fetchMe());
    if (err) return [err];
    localDataService.saveMe(value.data.data);
    return [null, value.data.data];
  };

  fetchLicensePlates = async () => {
    const [err, value] = await fromApi(api.fetchLicensePlates());
    if (err) return [err];
    localDataService.saveLicensePlates(value.data.data);
    return [null, value.data.data];
  };

  fetchActiveLicensePlates = async () => {
    const [err, value] = await fromApi(await api.fetchActiveLicensePlates());
    if (err) return [err];
    return [null, value.data.data.plateNumbers || []];
  };

  fetchOrders = async (transactionType, page = 1) => {
    const [err, value] = await fromApi(api.fetchOrders(transactionType, page));
    if (err) return [err];
    let data = value.data.data;
    data.sort((a, b) => {
      return Date.parse(b.createdAt) - Date.parse(a.createdAt);
    });
    const result = {
      ordersData: data,
      currentPage: page,
      totalPage: value.data.paging.total_page,
    };
    localDataService.saveOrders(data);
    return [null, result];
  };

  fetchOrdersSummary = async () => {
    const [err, value] = await fromApi(await api.ordersSummary());
    if (err) return [err];
    localDataService.saveOrdersSummary(value.data.data);
    return [null, value.data.data];
  };

  sendUserReports = async (transactionType, plateNumber, startAt, endAt, ubn) => {
    const [err, value] = await fromApi(api.sendUserReports(transactionType, plateNumber, startAt, endAt, ubn));
    if (err) return [err];
    return [null, value];
  };

  fetchOilPricing = async () => {
    const [err, value] = await fromApi(api.fetchOilPricing());
    if (err) return [err];
    return [null, prettify(value.data.data)];
  };
}

export default new Repository();
